import *as _ from 'lodash'
import {ClassificationBO} from "./ClassificationBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {SearchBO} from "./SearchBO";
import {WB_ClassificationStepRow, WB_ClassificationStepRRow} from "../PA.Core/PAdbSchemaRows";


export class ClassificationBOValidation {

    static Validate(aBO: ClassificationBO): Promise<void> {
        return new Promise<void>((resolve, error) => {
            ClassificationBOValidation.ValidateHeaderFields(aBO)
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }

                    return ClassificationBOValidation.ValidateSteps(aBO)
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }

                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    static async ValidateHeaderFields(aBO: ClassificationBO): Promise<void> {

        const self = this;
        let name = aBO.WB_Classification.cif.CLASSIFICATION_NAME

        if(name == '') {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'MissingName',
                    type: MessageType.Error,
                    title: "Name cannot be empty",
                    description:"Name cannot be empty.",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('MissingName')
        }

        let id = aBO.WB_Classification.cif.CLASSIFICATION_ID

        if(id == '') {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'MissingID',
                    type: MessageType.Error,
                    title: "ID cannot be empty",
                    description:"ID cannot be empty.",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('MissingID')
        }

        let tagGroup = aBO.WB_Classification.cif.WB_TAG_GROUP_ID

        if(tagGroup <= 0) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'MissingTagGroup',
                    type: MessageType.Error,
                    title: "Tag Group cannot be empty",
                    description:"Tag Group cannot be empty.",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('MissingTagGroup')
        }

        let tagCat = aBO.WB_Classification.cif.WB_TAG_CATEGORY_ID

        if(tagCat <= 0) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'MissingTagCategory',
                    type: MessageType.Error,
                    title: "Tag Category cannot be empty",
                    description:"Tag Category cannot be empty.",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('MissingTagCategory')
        }

        let entityDimension = aBO.WB_Classification.cif.ENTITY_DIMENSION

        if(tagCat <= 0) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'MissingEntityDimension',
                    type: MessageType.Error,
                    title: "Entity cannot be empty",
                    description:"Entity cannot be empty.",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('MissingEntityDimension')
        }

        let searchType = aBO.WB_Classification.cif.ALGORITHM_TYPE

        if(searchType == '') {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'MissingType',
                    type: MessageType.Error,
                    title: "Type cannot be empty",
                    description:"Type cannot be empty.",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('MissingType')
        }
    }

    static async ValidateSteps(aBO: ClassificationBO): Promise<void> {

        const self = this;
        let activeSteps = _.filter(aBO.WB_Classification.WB_ClassificationStepRows, aRow => aRow.isActive)

        _.forEach(activeSteps, (aStep: WB_ClassificationStepRow) => {
            let tagConditions: WB_ClassificationStepRRow[] = _.filter(aStep.WB_ClassificationStepRRows, aStepR => aStepR.isActive)
            if(tagConditions.length == 0) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'MissingTagConditions'+_.toString(aStep.cif.WB_CLASSIFICATION_STEP_ID),
                        type: MessageType.Error,
                        title: "At least 1 Tag Condition is required for every tag row existing in the setup grid.",
                        description:"At least 1 Tag Condition is required for every tag row existing in the setup grid.",
                        count: 0
                    })
            }
            else {
                aBO.ValidateMessageProvider.removeMessage('MissingTagConditions'+_.toString(aStep.cif.WB_CLASSIFICATION_STEP_ID))
            }

            let missingValueTagConditions = _.filter(tagConditions, aCond => aCond.cif.VALUE == '')
            if(missingValueTagConditions.length > 0) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'MissingTagConditionValue'+_.toString(aStep.cif.WB_CLASSIFICATION_STEP_ID),
                        type: MessageType.Error,
                        title: "Tag Condition Value cannot be empty.",
                        description:"Tag Condition Value cannot be empty.",
                        count: 0
                    })
            }
            else {
                aBO.ValidateMessageProvider.removeMessage('MissingTagConditionValue'+_.toString(aStep.cif.WB_CLASSIFICATION_STEP_ID))
            }
        })
    }
}